import React from "react";
import { Formik, Form } from "formik";
import { useUserStore } from "(store)/useUserStore";
import { toast } from "react-toastify";
import { NotificationSettingSchema } from "utils/Validation";
import { SettingNotificationForm } from "components/forms";
import { getProfile, updateProfile } from "services/admin.service";

const Notifications = () => {
  const { userInfo, setUser } = useUserStore();

  const initialValues = {
    isPushNotification: userInfo?.isPushNotification || false,
    isNotificationSound: userInfo?.isNotificationSound || false,
    isEmailNotification: userInfo?.isEmailNotification || false,
  };

  // update zustand
  const fetchProfile = async () => {
    getProfile()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          if (data) {
            setUser(data);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSwitchChange = async (name, value) => {
    const formData = new FormData();

    const payload = {
      [name]: value,
    };
    formData.append("data", JSON.stringify(payload));

    try {
      await updateProfile(formData);
      fetchProfile();
    } catch (error) {
      toast.error(error?.error || `Notification update failed`);
    }
  };

  return (
    <div className="min-h-screen p-5 border dark:border-gray-800 dark:bg-[#181818] my-5 mx-5 2xl:mx-14 rounded-lg shadow-lg">
      <div className="w-full border-0 border-b dark:border-b-gray-800 py-4">
        <p className="text-xl text-secondary dark:text-alpha">Notifications</p>
        <p className="text-md text-[#737373] dark:text-gray-300">
          Spade Rent property management software helps manage, grow, and
          automate hundreds of thousands of properties in over 100 countries.
        </p>
      </div>
      <div className="flex-1 flex flex-col">
        <Formik
          initialValues={initialValues}
          validationSchema={NotificationSettingSchema}
        >
          {({ values }) => (
            <Form className="flex-1 flex flex-col justify-between">
              <SettingNotificationForm onSwitchChange={handleSwitchChange} />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Notifications;
